import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverNoticeService } from '@app/driver-notice/driver-notice.service';
import { DriverNoticeComponent } from '@app/driver-notice/driver-notice/driver-notice.component';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    InfiniteScrollModule
  ],
  declarations: [DriverNoticeComponent],
  providers: [DriverNoticeService],
  entryComponents: [DriverNoticeComponent]
})
export class DriverNoticeModule { }



// WEBPACK FOOTER //
// ./src/app/driver-notice/driver-notice.module.ts